<template>
  <div>
    <Header />

    <div class="container-fluid" style="min-height: 60vh">
      <slot></slot> <!-- сюда вставляется контент страницы -->
    </div>

    <Footer />
    <CookieModal/>
  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import CookieModal from '@/components/shared/CookieModal.vue';

export default {
  components: {
    Header,
    Footer,
    CookieModal,
  }
}
</script>
